import {generateTheme} from 'providers/themeMain';

export const themeDarkPoppins = generateTheme({
   palette: {
      mode: 'dark',
   },
   components: {
      MuiPaper: {
         styleOverrides: {
            root: {
               boxShadow:
                  '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgb(0 214 245 / 30%)',
            },
         },
      },
      MuiOutlinedInput: {
         styleOverrides: {
            root: {
               '&.Mui-disabled': {
                  background: '#000',
               },
            },
         },
      },
   },
});
